<label *ngFor="let item of getItems(['deliverySelectable', 'deliveryOverlay'])"
       class="is-flex is-pointer is-align-items-flex-start ml-0 p-2 is-block"
       [ngClass]="isDynamicArticleInCart(item.id) ? 'is-active has-background-grey-light' : '' ">
    <input *ngIf="(getItems(['deliverySelectable', 'deliveryOverlay'])?.length ?? 0) > 1 " type="radio" name="deliverySelectable"
           class="mt-1 mr-2" [checked]="isDynamicArticleInCart(item.id)" (change)="toggleItem(item.id, $event)" (click)="_onSelectItem(item.id, $event)" [disabled]="!writeable">
    <input *ngIf="(getItems(['deliverySelectable', 'deliveryOverlay'])?.length ?? 0) <= 1 && item.deletable" type="checkbox"
           name="dynamic-article[]" class="mt-1 mr-2" [checked]="isDynamicArticleInCart(item.id)" (change)="toggleItem(item.id, $event)" (click)="_onSelectItem(item.id, $event)"  [disabled]="!writeable">
    <img *ngIf="item.images && item.images[0]" alt="{{item.name}}" class="dynamic-article-img"
         src="{{resourceUrl + item.images[0].thumbnails.small}}">
    <p>
        <b>
            {{ item.name }} <!-- {{ item.id }}-->
            <span *ngIf="(customer$ | async)?.priceMode == 'net'">
                <span *ngIf="item.netPrice !=0"> Pauschal {{ NumberFormat(item.netPrice, currency) }}</span>
                <span *ngIf="item.netPricePerArticle !=0"> Pro Artikel {{ NumberFormat(item.netPricePerArticle, currency) }}</span>
            </span>
            <span *ngIf="(customer$ | async)?.priceMode == 'gross'">
                 <span *ngIf="item.netPrice !=0"> Pauschal {{ NumberFormat((item.netPrice / 100) * (100 + item.taxRate), currency) }}</span>
                <span *ngIf="item.netPricePerArticle !=0"> Pro Artikel {{ NumberFormat((item.netPricePerArticle / 100) * (100 + item.taxRate), currency) }}</span>
            </span>


        </b>
        <br *ngIf="item.description"/>
        <span class="is-size-7">
      {{ item.description }}
    </span>

    </p>
</label>
<label *ngFor="let item of getItems(['selection', 'selectionWithOptionalMappingToCustomer', 'additionalArticle'])"
       class=" is-flex is-pointer is-align-items-flex-start ml-0 p-2 is-block"
       [ngClass]="(!item.deletable )? '' : 'checkbox'">
    <input type="checkbox" class="mt-1 mr-1" name="{{item.id}}" [disabled]="(!item.deletable)"  [disabled]="!writeable"
           (change)="toggleItem(item.id, $event)"
           [checked]="isDynamicArticleInCart(item.id)">
    <img *ngIf="item.images && item.images[0]" alt="{{item.name}}" class="dynamic-article-img"
         src="{{resourceUrl + item.images[0].thumbnails.small}}">
    <p>
        {{ item.name }}<!-- {{ item.id }}-->
        <span  *ngIf="(customer$ | async)?.priceMode == 'net'">
                <span *ngIf="item.netPrice !=0"> / Pauschal {{ NumberFormat(item.netPrice, currency) }}</span>
                <span *ngIf="item.netPricePerArticle !=0"> / Pro Artikel {{ NumberFormat(item.netPricePerArticle, currency) }}</span>
            </span>
        <span *ngIf="(customer$ | async)?.priceMode == 'gross' || !(customer$ | async)?.priceMode">
                 <span *ngIf="item.netPrice !=0"> / Pauschal {{ NumberFormat((item.netPrice / 100) * (100 + item.taxRate), currency) }}</span>
                <span *ngIf="item.netPricePerArticle !=0"> / Pro Artikel {{ NumberFormat((item.netPricePerArticle / 100) * (100 + item.taxRate), currency) }}</span>
            </span>
        <span *ngIf="item.description" class="is-size-7 mt-1 is-block">{{ item.description }}</span>
    </p>

</label>
